import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, toast, ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { useStore } from 'src/stores';
import { newTeamMemberSchema } from 'src/utils/formValidation/NewTeamMember';
import { YEmailValidateDefault } from 'src/utils/formValidation/yupValidators';
import { translate } from 'src/utils/translator';
import useStyles from './styles';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
export const EditTeamMemberPersonalDetailsModalContent = observer(_ref => {
  var _formik$values, _formik$values2;
  let handleModalClose = _ref.handleModalClose,
    dataMember = _ref.dataMember,
    isLoading = _ref.isLoading,
    triggerRefresh = _ref.triggerRefresh;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenInternal = _useState2[0],
    setIsOpenInternal = _useState2[1];
  const _useState3 = useState({
      isInvalid: false,
      isValidating: false,
      showWarning: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    emailValidation = _useState4[0],
    setEmailValidation = _useState4[1];
  /** Holds the in-flight email validation, so submit can wait for a check started by the blur it caused. */
  const emailValidationRef = useRef(null);
  const emailTooltipText = t('add_new_property_flow.invite_to_the_system');
  let newTeamMemberInitialValues = _objectSpread(_objectSpread({}, dataMember), {}, {
    email: (dataMember === null || dataMember === void 0 ? void 0 : dataMember.email) || (dataMember === null || dataMember === void 0 ? void 0 : dataMember.newEmail),
    phone: dataMember.phone ? dataMember.phone.replace('+1', '').replace('+38', '') : ''
  });
  const updateEmailByAccountId = async data => {
    const resp = await store.account.updateEmailByAccountIdAsync.run(beforeSubmitDataValidation(data));
    return resp;
  };
  const updateProfileByAccountId = async data => {
    const resp = await store.account.updateProfileByAccountIdAsync.run(beforeSubmitDataValidation(data));
    return resp;
  };
  const updatePhoneByAccountId = async data => {
    const resp = await store.account.updatePhoneByAccountIdAsync.run(beforeSubmitDataValidation(data));
    return resp;
  };
  const formik = useFormik({
    initialValues: newTeamMemberInitialValues,
    validationSchema: newTeamMemberSchema,
    onSubmit: async values => {
      toast('loading', {
        body: ['Saving...']
      }); // ? i18n

      const email = values.email,
        firstName = values.firstName,
        lastName = values.lastName,
        phone = values.phone;
      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const promises = [];
      if (email !== newTeamMemberInitialValues.email) promises.push(updateEmailByAccountId({
        accountId: dataMember.accountId,
        email
      }));
      if (firstName !== newTeamMemberInitialValues.firstName || lastName !== newTeamMemberInitialValues.lastName) promises.push(updateProfileByAccountId({
        accountId: dataMember.accountId,
        firstname: firstName,
        lastname: lastName
      }));
      if (phone !== newTeamMemberInitialValues.phone) promises.push(updatePhoneByAccountId({
        accountId: dataMember.accountId,
        phone: "".concat(phoneCode).concat(phone.replace(/[^0-9+]/g, ''))
      }));
      if (!promises.length) return;
      Promise.all([...promises]).then(responses => {
        if (responses.some(response => !response.isSuccessful)) return;
        newTeamMemberInitialValues = _objectSpread({}, values);
        toast('success', {
          body: [t('general.successfully_updated')]
        });
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      triggerRefresh && triggerRefresh();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      handleModalClose && handleModalClose();
    }
  });
  useEffect(() => {
    if (!isOpenInternal) {
      // store.addNewProperty.contactInformation.resetNotSavedNewUnitTeamMember();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenInternal]);
  const runEmailValidation = async email => {
    try {
      var _resp$response;
      setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        isValidating: true
      }));
      const resp = await store.account.validateEmailAsync.run({
        email
      });
      const isInvalid = !!(resp !== null && resp !== void 0 && resp.isSuccessful) && ((_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.result) !== 'deliverable';
      setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        isInvalid,
        showWarning: isInvalid
      }));
      return isInvalid;
    } catch (_unused) {
      setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        isInvalid: false
      }));
      return false;
    } finally {
      setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        isValidating: false
      }));
    }
  };
  const handleEmailBlur = e => {
    const email = e.target.value;
    if (!email) return;
    formik.handleBlur(e);
    if (!YEmailValidateDefault.isValidSync(email)) return;
    const validation = runEmailValidation(email);
    emailValidationRef.current = validation;
    validation.finally(() => {
      if (emailValidationRef.current === validation) emailValidationRef.current = null;
    });
  };
  const handleEmailChange = e => {
    formik.handleChange(e);
    setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
      isInvalid: false
    }));
    emailValidationRef.current = null;
  };
  const handleFormSubmit = async e => {
    e.preventDefault();
    const pendingEmailValidation = emailValidationRef.current;
    if (pendingEmailValidation) {
      const isInvalid = await pendingEmailValidation;
      if (isInvalid) return;
    }
    if (emailValidation.isInvalid) return;
    formik.handleSubmit();
  };
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('general.personal_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    label: t('general.first_name'),
    variant: "outlined",
    value: (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.firstName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      // handleChangeInputValue('firstName', e.target.value);
    },
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && translate(formik.errors.firstName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    label: t('general.last_name'),
    variant: "outlined",
    value: (_formik$values2 = formik.values) === null || _formik$values2 === void 0 ? void 0 : _formik$values2.lastName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      // if (!teamMemberPage) handleChangeInputValue('lastName', e.target.value);
    },
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && translate(formik.errors.lastName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    error: formik.touched.email && Boolean(formik.errors.email),
    onBlur: handleEmailBlur,
    onChange: handleEmailChange
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "email"
  }, t('general.email_address')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "email",
    type: "email",
    label: t('general.email_address'),
    value: formik.values.email,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      type: "infoTooltip"
    }, emailValidation.isValidating ? /*#__PURE__*/React.createElement(CircularProgress, {
      size: 20
    }) : /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: emailTooltipText,
      type: "grey"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "question"
    }))))
  }), formik.touched.email && !!formik.errors.email && /*#__PURE__*/React.createElement(FormHelperText, null, translate(formik.errors.email, t)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: e => {
      formik.handleChange(e);
      // if (!teamMemberPage) handleChangeInputValue('phone', e.target.value);
    },
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) formik.setFieldTouched('phone', true);
    }
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    helperText: formik.touched.phone && translate(formik.errors.phone, t)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.formFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    type: "button",
    onClick: handleModalClose,
    'custom-attribute': '289-edit-teammember-modal-v2'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    disabled: !formik.isValid || !Object.keys(formik.touched).length || emailValidation.isInvalid,
    'custom-attribute': '290-edit-teammember-modal-v2'
  }, t('buttons.save')))))), /*#__PURE__*/React.createElement(Dialog, {
    open: emailValidation.showWarning,
    onClose: () => setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
      showWarning: false
    }))
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Email Validation"), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, null, "The email address you entered appears to be invalid or undeliverable. Please verify the email address and try again.")), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
      showWarning: false
    })),
    variant: "contained"
  }, "OK"))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.account.inviteNewUserV2Async.inProgress || store.teamMembers.createNewTeamMemberAsync.inProgress
  }));
});